module.exports = __webpack_public_path__ + "static/media/nove.89510729.png";